import { Helmet } from 'react-helmet-async';
// @mui
import {
    Card,
    Stack,
    Container,
    Typography,
    TableContainer,
    CardContent,
    Button,
    CircularProgress,
    Box,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    ToggleButtonGroup, ToggleButton, Link,
} from '@mui/material';

import {useNavigate, useParams} from 'react-router-dom';

// components
import Scrollbar from '../components/scrollbar';
// sections
import { StepByStepTable } from "../sections/@dashboard/attestations";
import {GeneralLayout} from "../layouts/GeneralLayout";
import Label from "../components/label";
import TextField from "@mui/material/TextField";
import {useEffect, useState} from "react";
import {useGetNextAttestationNumberQuery, usePostCreateAttestationMutation} from "../store/attestation/attestationApi";
import PageTitle from "../components/PageTitle";
import MenuItem from "@mui/material/MenuItem";
import {ChangeCircle, Save} from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import FileUploadButton from "../sections/@dashboard/common/FileUploadButton";
import {
    useCloseSessionStatementMutation,
    useGetStatementInfoQuery,
    useGetStatementResultsQuery
} from "../store/statement/statementApi";
import copyObject from "../utils/copyObject";
import StatementInfoBlock from "../sections/@dashboard/sessions/StatementInfoBlock";
import CheckIcon from "@mui/icons-material/Check";
import MainLayout from "./main";

export default function CloseStatementPage() {
    const {id} = useParams();
    const [links, setLinks] = useState([]);
    const navigate = useNavigate();
    const [isSaving, setIsSaving] = useState(false);
    const {data} = useGetStatementInfoQuery({statementId: id});
    const results = useGetStatementResultsQuery({statementId: id});
    const [copyOfResults, setCopyOfResults] = useState([]);
    const [closeStatementRequest] = useCloseSessionStatementMutation();
    
    useEffect(() => {
        if (results?.data !== null && results?.data !== undefined && results) {
            setCopyOfResults(copyObject(results.data));
        }        
    }, [data, results]);

    async function closeStatement() {
        setIsSaving(true);
        await closeStatementRequest({
            data: {
                statementId: id
            }
        }).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                navigate('/mystatements')
            } else {
                console.log(fulfilled.errors);
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });

                setIsSaving(false);
            }
        }).catch(() => {
            setIsSaving(false);
            alert('Ошибка');
        });
    }

    function formatDate(dateObj) {
        return `${dateObj.getFullYear()}-${withZero(dateObj.getMonth() + 1)}-${withZero(dateObj.getDate())}`;
    }

    function toDateString(date){
        if (date === null || date === undefined)
            return '';

        return new Date(date).toLocaleDateString("ru-RU");
    }

    function withZero(num) {
        return num < 10 ? `0${num}` : num;
    }

    const handleSave = async () => {
        setIsSaving(true);

        // await createAttestation({courseId: id, startDate, endDate}).unwrap().then((fulfilled) => {
        //     if (fulfilled?.success) {
        //         navigate('/facultyattestations');
        //     } else {
        //         fulfilled.errors.map((item) => {
        //             alert(item);
        //             return 1;
        //         });
        //
        //         setIsSaving(false);
        //     }
        // });
    };

    function getCorrectFsLink(link) {
        // костыль для того, чтобы можно было скачивать файлы из тестового хранилища

        const cachedLink = links.find((item) => item.link === link);
        if (cachedLink !== undefined) {
            console.log('Ссылка найдена в кэше')
            window.open(cachedLink.correctLink, '_blank')
            return;
        }
        console.log('ссылка не найдена в кэше, определяем корректную форму')

        try {
            fetch(link)
                .then((resp) => {
                    console.log('response', resp);
                    if (resp.status === 404) {
                        console.log(`${link} = 404`)
                        links.push({
                            link,
                            correctLink: `${link}?useTest=1`
                        })

                        window.open(`${link}?useTest=1`, '_blank')
                    }
                    else if (resp.status === 200 || resp.status === 300) {
                        links.push({
                            link,
                            correctLink: `${link}`
                        })

                        window.open(`${link}`, '_blank')
                    }
                }).catch((resp) => {
                console.log('error', resp)
                links.push({
                    link,
                    correctLink: `${link}?useTest=1`
                })
            })
        } catch (err) {
            console.log('catch', err)
            console.log(links)
        }
    }

    return (
        <MainLayout>
            <PageTitle title={`Закрыть ведомость`} />

            <Container>
                <Stack direction="column"
                       padding="30px 0px 0px 0px"
                       spacing={2}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4" gutterBottom>
                            {data === null || data === undefined ? <CircularProgress /> : <></>}
                            Проверьте ведомость №{data?.statement.statementNumber} перед закрытием
                        </Typography>
                    </Stack>

                    <StatementInfoBlock statement={data?.statement}
                                        printEnabled={false}
                                        adminMode={false}/>

                    <Card>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>#</TableCell>
                                    <TableCell>ФИО студента</TableCell>
                                    <TableCell>Оценка</TableCell>
                                    <TableCell align={'center'}>Допуск</TableCell>
                                    {data?.statement?.controlType === 3 || data?.statement?.controlType === 4
                                        ? <TableCell align={"right"}>Рецензия/Работа</TableCell>
                                        : <></>}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {copyOfResults.students?.sort((left, right) => left.lastName > right.lastName ? 1 : -1).map((student, index) => {
                                    return (
                                        <TableRow>
                                            <TableCell><Typography
                                                fontSize="x-large">{index + 1}</Typography></TableCell>
                                            <TableCell>
                                                <Typography>
                                                    <strong>{student.lastName}</strong>
                                                    <br/>{student.firstName} {student.middleName}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography
                                                    color={student.gradeId === 2 || student.gradeId === 7 || student.gradeId === 6
                                                        ? 'red'
                                                        : student.gradeId === 3
                                                            ? 'orange'
                                                            : 'green'}>
                                                    {student.gradeName}
                                                </Typography>
                                                {student.points ? <Typography fontSize={"small"}>{student.points.toFixed(2)} баллов</Typography> : ''}
                                                {student.registryDocumentGuid !== null
                                                    ?
                                                    <Typography fontSize={"small"}>Перезачтено на основании документа <Link
                                                        onClick={() => getCorrectFsLink(`https://fs.kubsau.ru/file/${student.registryDocumentGuid}`)}
                                                        target={'_blank'}>{student.registryDocumentNumber} от {toDateString(student.registryDocumentDate)}</Link></Typography>
                                                    : <></>}
                                            </TableCell>
                                            <TableCell align={'center'}>
                                                <Typography color={!student.notAllowed? 'green' : 'red'}>
                                                    {!student.notAllowed ? 'Допущен' : 'Не допущен'}
                                                </Typography>

                                            </TableCell>
                                            {data?.statement?.controlType === 3 || data?.statement?.controlType === 4
                                                ? <TableCell align={"right"}>
                                                    {student.theme !== null && student.theme !== undefined
                                                        ? <><strong>Тема работы: </strong>{student.theme}</>
                                                        : <></>}

                                                    {student.reviewFile !== null && student.reviewFile !== undefined
                                                        ? <FileUploadButton maxFileSize={0} title={'Рецензия'}
                                                                            uploadingEnabled={false}
                                                                            existingFileGuid={student.reviewFile}/>
                                                        : <></>}

                                                    {student.courseWorkFile !== null && student.courseWorkFile !== undefined
                                                        ? <FileUploadButton maxFileSize={0} title={'Работа'}
                                                                            uploadingEnabled={false}
                                                                            existingFileGuid={student.courseWorkFile}/>
                                                        : <></>}
                                                </TableCell>
                                                : <></>}
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </Card>


                    <Button variant={'contained'}
                            disabled={isSaving}
                            startIcon={isSaving ? <CircularProgress size={15} /> : <CheckIcon />}
                            onClick={() => {closeStatement()}}>Закрыть ведомость</Button>
                    
                    <br />
                </Stack>
            </Container>
        </MainLayout>
    );
}
